import React from 'react'
import useUser from '../Hooks/useUser'
import { Link } from 'react-router-dom';
import { FaUserAlt, FaSignOutAlt, FaSignInAlt, FaUserPlus } from 'react-icons/fa';


function AccoundDropdown() {

    const userState = useUser();

    return (
        <div className='shadow-lg rounded-lg min-w-max bg-gradient-to-b from-violet-600 to-indigo-600 border border-violet-400'>
            {userState.userId ? (
                <>
                    <Link
                        to="/deleteAccount"
                        className='flex items-center gap-3 px-4 py-3 text-white font-body text-base hover:bg-white hover:bg-opacity-10 rounded-t-lg transition-colors'
                    >
                        <FaUserAlt size={16} />
                        <span>Conta</span>
                    </Link>
                    <button
                        onClick={userState.signOut}
                        className='w-full text-left flex items-center gap-3 px-4 py-3 text-white font-body text-base hover:bg-white hover:bg-opacity-10 rounded-b-lg transition-colors'
                    >
                        <FaSignOutAlt size={16} />
                        <span>Sair</span>
                    </button>
                </>
            ) : (
                <>
                    <Link
                        to="/login"
                        className='flex items-center gap-3 px-4 py-3 text-white font-body text-base hover:bg-white hover:bg-opacity-10 rounded-t-lg transition-colors'
                    >
                        <FaSignInAlt size={16} />
                        <span>Entrar</span>
                    </Link>
                    <Link
                        to="/signup"
                        className='flex items-center gap-3 px-4 py-3 text-white font-body text-base hover:bg-white hover:bg-opacity-10 rounded-b-lg transition-colors'
                    >
                        <FaUserPlus size={16} />
                        <span>Criar</span>
                    </Link>
                </>
            )}
        </div>
    )
}

export default AccoundDropdown